// extracted by mini-css-extract-plugin
export var blue15 = "section-module--blue15--c845c";
export var blue50 = "section-module--blue50--f1735";
export var blue75 = "section-module--blue75--e7f6d";
export var dark = "section-module--dark--025ed";
export var green = "section-module--green--6a731";
export var green25 = "section-module--green25--ab301";
export var grey = "section-module--grey--72949";
export var pink = "section-module--pink--47db9";
export var pink10 = "section-module--pink10--3792a";
export var pink75 = "section-module--pink75--873b9";
export var purple50 = "section-module--purple50--f168f";
export var purple500 = "section-module--purple500--04c40";
export var purple900 = "section-module--purple900--b1cb0";
export var section = "section-module--section--94161";